import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { RGS_AGENT_REGISTRATON, addTestAttribute } from '@shared/index';

import { Button } from './rgs-agent-registration-button.styles';

export const IS_RGS_AGENT_SEARCH_PARAMS = 'rgs-agent';

export const RGSAgentRegistrationButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClickImRGSAgent = () => {
    navigate(RGS_AGENT_REGISTRATON);
  };

  return (
    <Button
      onClick={onClickImRGSAgent}
      {...addTestAttribute('registration.button.rgsAgent')}
    >
      {t('REGISTRATION:button.rgsAgent')}
    </Button>
  );
};
